import { propertyNamesService } from './propertyNamesService';
import { propertiesStorage } from './propertiesStorage';

const resolveProperty = (propertyOrId) => {
    if (propertyOrId && typeof propertyOrId === 'object') {
        const fromStorage = propertiesStorage.propertiesList.find(
            (it) => it.id === propertyOrId.id || it.propertyName === propertyOrId.propertyName,
        );
        if (!fromStorage) {
            return propertyOrId;
        }
        // Detail payload (e.g. propertySaveService) may carry valueNames that list storage lacks.
        const callerNames = propertyOrId.valueNames?.length ?? 0;
        const storedNames = fromStorage.valueNames?.length ?? 0;
        if (callerNames > storedNames) {
            return { ...fromStorage, valueNames: propertyOrId.valueNames };
        }
        return fromStorage;
    }
    if (typeof propertyOrId === 'string') {
        return propertiesStorage.propertiesList.find(
            (it) => it.id === propertyOrId || it.propertyName === propertyOrId,
        );
    }
    return null;
};

const propertiesService = {
    getPropertyTypei18nCode(propertyData) {
        if (propertyData.propertyType) return `product.scheme.property.propertyType.${propertyData.propertyType}`;
        return 'app.page.product.notAssigned';
    },
    getPropertyCategoryi18nCode(propertyData) {
        if (propertyData.categoryName) return `product.scheme.property.categoryName.${propertyData.categoryName}`;
        return 'app.page.product.notAssigned';
    },
    getPropertyVitaminTypei18nCode(propertyData) {
        return `product.scheme.property.vitamin.${propertyData.isWaterSoluble ? 'waterSoluble' : 'fatSoluble'}`;
    },
    getLocalization(localeCode, propertyOrCode, withCodeReplace, i18nInstance) {
        return propertyNamesService.getLocalization(localeCode, propertyOrCode, withCodeReplace, i18nInstance);
    },
    getPlaceholder(i18nInstance) {
        return propertyNamesService.getPlaceholder(i18nInstance);
    },
    getPropertyValueLocalization(value, localeCode, propertyOrId) {
        const property = resolveProperty(propertyOrId);
        if (property?.valueNames?.length) {
            const found = property.valueNames.find(
                (it) => it.valueCode === value && it.locale === localeCode,
            );
            if (found?.name) {
                return found.name;
            }
        }
        // No localized name yet — show the select code (e.g. water) so edit form is not blank.
        return value || '';
    },
    upsertValueNameInStorage(propertyId, locale, valueCode, name) {
        const storedProperty = propertiesStorage.getById(propertyId);
        if (!storedProperty) {
            return;
        }
        if (!storedProperty.valueNames) {
            storedProperty.valueNames = [];
        }
        const existing = storedProperty.valueNames.find(
            (it) => it.valueCode === valueCode && it.locale === locale,
        );
        if (existing) {
            existing.name = name;
        } else {
            storedProperty.valueNames.push({
                valueCode,
                locale,
                name,
            });
        }
    },
};

export { propertiesService };
